<template>
    <mt-loadmore :bottom-method="getSimDistributRecordHandler" :bottom-all-loaded="allLoaded" :auto-fill="false"
        ref="loadmore">
        <div class="vant-card">
            <div class="dataFrom">
                <van-cell-group>
                    <van-field v-model="dataFrom.iccidStart" label="开始号段" placeholder="请输入开始iccid/虚拟号" />
                </van-cell-group>
                <van-cell-group>
                    <van-field v-model="dataFrom.iccidEnd" label="结束号段" placeholder="请输入结束iccid/虚拟号" />
                </van-cell-group>
                <div class="line">
                    <label>批量查询</label>
                    <div class="">
                        <textarea v-model="dataFrom.iccid" rows="5" placeholder="多个卡号请用空格或者换行分隔"></textarea>
                    </div>
                </div>

            </div>
            <mt-button type="primary" size="large" @click="handleSearch" class="search-button">搜索</mt-button>
            <mt-button type="primary" size="large" @click="updateReload" class="reload-button">批量刷新复机</mt-button>
            <div class="content">
                <div class="card-item" v-for="item in dataList" :key="item.id">
                    <!-- 卡片头部 - 核心信息区 -->
                    <div class="card-header">
                        <div class="main-info">
                            <div class="iccid-box">
                                <span class="label">ICCID：</span>
                                <span class="value">{{ item.iccid }}</span>
                            </div>
                            <div class="vriNo-box">
                                <span class="label">卡号：</span>
                                <div class="value-with-copy">
                                    <span class="value">{{ item.vriNo }}</span>
                                    <button class="copy-btn" @click="copyToClipboard(item.vriNo)">
                                        <van-icon name="copy" size="14" />
                                        <span class="copy-text">复制</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="status-tag-group">
                            <span class="status-tag"
                                :class="{ 'active': item.stateName === '已激活', 'inactive': item.stateName === '停机', 'expired': item.stateName === '故障' }">
                                {{ item.stateName }}
                            </span>
                            <span class="auth-tag"
                                :class="{ 'verified': item.authName === '已实名', 'unverified': item.authName === '未实名' }">
                                {{ item.authName }}
                            </span>
                        </div>
                    </div>

                    <!-- 新增：操作按钮区域 -->
                    <div class="card-actions">
                        <button class="action-btn restore-btn" @click="simMgr(item.iccid, 0)">
                            复机
                        </button>
                        <button class="action-btn stop-btn" @click="simMgr(item.iccid, 1)">
                            停机
                        </button>
                        <button class="action-btn reset-btn" @click="simMgr(item.iccid, 2)">
                            重置网络
                        </button>
                    </div>

                    <!-- 卡片主体 - 流量信息区 -->
                    <div class="card-body">
                        <div class="flow-info">
                            <div class="flow-item">
                                <span class="flow-label">总流量</span>
                                <span class="flow-value">{{ (item.flow_rate / 1024).toFixed(2) }}GB</span>
                            </div>
                            <div class="flow-item">
                                <span class="flow-label">已用</span>
                                <span class="flow-value">{{ (item.used_flow_rate / 1024).toFixed(2) }}GB</span>
                            </div>
                            <div class="flow-item">
                                <span class="flow-label">剩余</span>
                                <span class="flow-value">{{ ((item.flow_rate - item.used_flow_rate) / 1024).toFixed(2)
                                }}GB</span>
                            </div>
                        </div>

                        <!-- 流量进度条 -->
                        <div class="flow-progress">
                            <div class="progress-bar">
                                <div class="progress-fill"
                                    :style="{ width: `${Math.min((item.used_flow_rate / item.flow_rate) * 100, 100)}%` }"
                                    :class="{ 'high-usage': (item.used_flow_rate / item.flow_rate) > 0.8 }"></div>
                            </div>
                            <div class="progress-text">
                                <span>用量 {{ Math.round((item.used_flow_rate / item.flow_rate) * 100) }}%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mt-loadmore>
</template>
<script>
import { Toast, Dialog } from 'vant';
import { wxRequest } from '@/api/agent.js'
export default {
    name: 'card',
    data() {
        return {
            dataFrom: {
                iccidStart: '',
                agentId: ''
            },
            pageNo: 0,
            perPageNum: 50,
            allPage: 0,
            pickerName: '',
            dataList: [],
            columns: [],
            showPicker: false,
            allLoaded: false
        }
    },
    created() {
        this.getSelect()
        this.getSimDistributRecordHandler()
    },
    methods: {
        // 0复机 1 停机 2刷新网络
        simMgr(iccid, type) {
            var url = "/sim/to/activitySim"
            if (type == 1) {
                url = "/sim/to/pauseSim"
            } else if (type == 2) {
                url = "/sim/to/reload"
            }
            wxRequest(url, { iccid: iccid }, 'post').then(res => {
                if (res.data.code === '200') {
                    this.$messagebox.alert(res.data.message)
                } else {
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        copyToClipboard(text) {
            if (!text) {
                Toast('无内容可复制');
                return;
            }
            // 创建临时文本框用于复制
            const textarea = document.createElement('textarea');
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            Toast('复制成功');
        },

        updateReload() {
            var data = {
                startIccid: this.dataFrom.iccidStart,
                endIccd: this.dataFrom.iccidEnd,
                batchIccid: this.dataFrom.iccid,
            }
            wxRequest('sim/reloadBatchSim', data, 'post').then(res => {
                if (res.data.code === '200') {
                    this.$messagebox.alert(res.data.message)
                    this.handleSearch()
                } else {
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        // 获取代理商数据
        getSelect() {
            wxRequest('/agent/list', {}, 'post').then(res => {
                if (res.data.code === '200') {
                    if (Array.isArray(res.data.data) && res.data.data.length > 0) {
                        res.data.data.forEach(item => {
                            this.columns.push({ id: item.id, text: item.name })
                        })
                    }
                } else {
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        // 初始化数据
        getSimDistributRecordHandler() {
            this.pageNo += 1;
            var data = {
                pageNo: this.pageNo,
                startIccid: this.dataFrom.iccidStart,
                endIccd: this.dataFrom.iccidEnd,
                batchIccid: this.dataFrom.iccid,
                perPageNum: this.perPageNum
            }
            wxRequest("sim/selectBatchSim", data, "post").then(res => {
                if (res.data.code == 200) {
                    this.dataList = res.data.data;
                } else {
                    this.$messagebox.alert(res.data.message)
                }
            })
        },
        // 查询
        handleSearch() {
            this.pageNo = 0
            this.dataList = []
            this.getSimDistributRecordHandler()
        },
        // 分销
        distribution() {
            if (!this.dataFrom.iccidStart) {
                Toast('请输入开始iccid')
                return
            }
            if (!this.dataFrom.iccidEnd) {
                Toast('请输入结束iccid')
                return
            }
            if (!this.dataFrom.agentId) {
                Toast('请选择代理商')
                return
            }
            Dialog.confirm({
                title: '提示',
                message: '确认进行分销？',
            }).then(() => {
                var data = {
                    iccidStart: this.dataFrom.iccidStart,
                    iccidEnd: this.dataFrom.iccidEnd,
                    agentId: this.dataFrom.agentId,
                }
                wxRequest("sim/soldList", data, "post").then(res => {
                    if (res.data.code == 200) {
                        this.$messagebox.alert(res.data.message)
                        this.handleSearch()
                    } else {
                        this.$messagebox.alert(res.data.message)
                    }
                })
            }).catch(() => {
                // on cancel
            });
        },
        // 回收
        agentLoginHandler() {
            if (!this.dataFrom.iccidStart) {
                Toast('请输入开始iccid')
                return
            }
            if (!this.dataFrom.iccidEnd) {
                Toast('请输入结束iccid')
                return
            }
            Dialog.confirm({
                title: '提示',
                message: '确认进行回收？',
            }).then(() => {
                var data = {
                    iccidStart: this.dataFrom.iccidStart,
                    iccidEnd: this.dataFrom.iccidEnd
                }
                wxRequest("sim/recoverList", data, "post").then(res => {
                    if (res.data.code == 200) {
                        this.$messagebox.alert(res.data.message)
                        this.handleSearch()
                    } else {
                        this.$messagebox.alert(res.data.message)
                    }
                })
            }).catch(() => {
                // on cancel
            });
        },
        onConfirm(value) {
            this.pickerName = value.text
            this.dataFrom.agentId = value.id
            this.showPicker = false;
        },
        onCancel() {
            this.showPicker = false;
        },
    }
}
</script>
<style lang="less" scoped>
// 新增：按钮样式
.card-item {
    // 确保卡片有足够空间容纳按钮
    padding-bottom: 20px;

    .card-actions {
        display: flex;
        gap: 8px;
        margin: 16px 0;
    }

    .action-btn {
        flex: 1;
        height: 36px;
        border: none;
        border-radius: 4px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        transition: opacity 0.2s;

        &:hover {
            opacity: 0.9;
        }
    }

    .restore-btn {
        background-color: #00b42a; // 绿色：复机
    }

    .stop-btn {
        background-color: #f53f3f; // 红色：停机
    }

    .reset-btn {
        background-color: #1677ff; // 蓝色：重置网络
    }
}

.van-cell:not(:last-child)::after {
    border: 0
}

.vant-card {
    min-height: 100%;
    background: #F5F5F5;
    padding-top: 10px;

    .search-button {
        margin: 16px 14px 0 14px;
        width: calc(100% - 28px);
        font-size: 14px;
        background: #1677FE;
        border-radius: 24px; // 让按钮变为椭圆形
        height: 48px;
    }

    .reload-button {
        margin: 16px 14px 0 14px;
        width: calc(100% - 28px);
        font-size: 14px;
        background: #FF7D00; // 设置不同的颜色
        border-radius: 24px; // 让按钮变为椭圆形
        height: 48px;
    }

    .card-item {
        background: #fff;
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        transition: transform 0.2s, box-shadow 0.2s;

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        }

        .card-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 16px;
            padding-bottom: 12px;
            border-bottom: 1px solid #f5f5f5;

            .main-info {
                flex: 1;

                .iccid-box,
                .vriNo-box {
                    display: flex;
                    align-items: center;
                    margin-bottom: 8px;

                    .value-with-copy {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                    }

                    .copy-btn {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        gap: 3px;
                        height: 22px; // 减小按钮高度
                        padding: 0 6px; // 只保留水平内边距
                        background: #f5f5f5;
                        border: none;
                        border-radius: 4px;
                        font-size: 12px;
                        line-height: 1; // 确保文字垂直居中
                        color: #666;
                        cursor: pointer;
                        white-space: nowrap; // 防止文字换行

                        &:hover {
                            background: #eeeeee;
                        }
                    }
                }
            }

            .status-tag-group {
                display: flex;
                flex-direction: column;
                gap: 6px;

                .status-tag {
                    padding: 4px 8px;
                    border-radius: 4px;
                    font-size: 12px;
                    font-weight: 500;

                    &.active {
                        background: #e6f4ea;
                        color: #00b42a;
                    }

                    &.inactive {
                        background: #fef2f2;
                        color: #f53f3f;
                    }

                    &.expired {
                        background: #fff8e6;
                        color: #ff7d00;
                    }
                }

                .auth-tag {
                    padding: 4px 8px;
                    border-radius: 4px;
                    font-size: 12px;
                    font-weight: 500;

                    &.verified {
                        background: #e8f3ff;
                        color: #1677ff;
                    }

                    &.unverified {
                        background: #f2f3f5;
                        color: #86909c;
                    }
                }
            }
        }

        .card-body {
            .flow-info {
                display: flex;
                justify-content: space-between;
                margin-bottom: 12px;
                padding: 0 4px;

                .flow-item {
                    text-align: center;
                    flex: 1;

                    .flow-label {
                        display: block;
                        color: #8c8c8c;
                        font-size: 12px;
                        margin-bottom: 4px;
                    }

                    .flow-value {
                        color: #333;
                        font-size: 14px;
                        font-weight: 500;
                    }
                }
            }

            .flow-progress {
                padding: 0 4px;

                .progress-bar {
                    height: 6px;
                    background: #f5f5f5;
                    border-radius: 3px;
                    overflow: hidden;

                    .progress-fill {
                        height: 100%;
                        background: #1677ff;
                        transition: width 0.3s ease;

                        &.high-usage {
                            background: #ff7d00;
                        }
                    }
                }

                .progress-text {
                    color: #8c8c8c;
                    font-size: 12px;
                    text-align: right;
                    margin-top: 6px;
                }
            }
        }
    }

    .dataFrom {
        margin: 0px 14px 16px 14px;
        padding: 8px;
        padding-left: 16px;
        padding-right: 16px;
        border-radius: 8px;
        background: #fff;

        [class*=van-hairline]::after {
            border: 0
        }

        .van-cell {
            border-bottom: 1px solid #F5F5F5;
            padding-bottom: 20px;
            padding-right: 0;
            padding-top: 16px;
        }

        .van-cell-group:last-child {
            .van-cell {
                border: 0
            }
        }

        .ksea {
            /deep/.van-cell__value {
                .van-field__control {
                    background: url(./../../assets/agent/icon5.png) no-repeat right center;
                    background-size: 13px 8px;
                }
            }
        }

        .van-cell-group {
            /deep/.van-cell__title {
                color: #000;
            }

            /deep/.van-cell__value {
                .van-field__control {
                    line-height: 24px;
                }
            }
        }
    }

    button {
        margin: 16px 14px 0 14px;
        width: calc(100% - 28px);
        font-size: 14px;
        background: #1677FE;
        border-radius: 8px;
        height: 48px;
    }

    .content {
        margin-top: 32px;
        margin-left: 14px;
        margin-right: 14px;
        background: #fff;
        padding: 16px;
        border-radius: 8px;

        .vant-v {
            border-bottom: 1px solid #F5F5F5;
            margin-bottom: 16px;

            .van-row {
                padding-bottom: 8px;

                .van-col--2 {
                    img {
                        width: 15px;
                        height: 16px;
                    }
                }

                .van-col--18 {
                    color: #000;
                    font-size: 14px;
                }

                .van-col--4 {
                    color: #1677FE;
                    font-size: 14px;
                    text-align: right;
                }

                .van-col--17 {
                    color: #999;
                    padding-bottom: 8px;
                    font-size: 12px;
                }

                .van-col--5 {
                    color: #1677FE;
                    font-size: 14px;
                    text-align: right;
                }
            }
        }
    }
}
</style>